import {
  CHECKOUT_DEFAULT_SELECTED_SHIP_OPTION,
  CHECKOUT_RESET_TO_DEFAULT_STATE,
  CLEAR_SHIP_OPTIONS_BY_GROUP,
  RECEIVE_NEW_SHIP_OPTIONS_FIELD,
  SET_CHECKOUT_SHIP_OPTIONS,
  STORE_SHIP_OPTIONS_BY_GROUP,
  STORE_SHIP_OPTIONS_FOR_EGC_ONLY_CART
} from 'constants/reduxActions';

const defaultState = {
  isLoaded: false,
  isLoading: false,
  showModal: false,
  groups: {}
};

export function shipOptions(state = defaultState, action = {}) {
  const {
    byLineItem,
    data,
    fieldKey,
    fieldValue,
    groupType,
    group,
    purchaseShipOptionId,
    type
  } = action;

  switch (type) {
    case SET_CHECKOUT_SHIP_OPTIONS: {
      const { deliveryOptions } = data;

      if (!deliveryOptions) {
        return state;
      }

      const { groupDeliveryOptions } = deliveryOptions;

      if (!groupDeliveryOptions) {
        return state;
      }

      const { lineItemDeliveryOptions, orderDeliveryOptions } = groupDeliveryOptions;

      if (!orderDeliveryOptions) {
        return state;
      }

      return { ...state, byLineItem: lineItemDeliveryOptions, saved: orderDeliveryOptions, isLoaded: true, isLoading: false, showModal: false };
    }

    case CLEAR_SHIP_OPTIONS_BY_GROUP: {
      return { ...state, groups: {} };
    }

    case STORE_SHIP_OPTIONS_FOR_EGC_ONLY_CART: {
      return { ...state, byLineItem };
    }

    case RECEIVE_NEW_SHIP_OPTIONS_FIELD: {
      const newShipOptions = { ...state.new, [fieldKey]: fieldValue };
      return { ...state, new: newShipOptions };
    }

    case CHECKOUT_DEFAULT_SELECTED_SHIP_OPTION: {
      const newShipOptions = { ...state.new, shipOptionId: purchaseShipOptionId };
      return { ...state, new: newShipOptions };
    }

    case STORE_SHIP_OPTIONS_BY_GROUP: {
      return { ...state, groups: { ...state.groups, [groupType]: group } };
    }

    case CHECKOUT_RESET_TO_DEFAULT_STATE: {
      return defaultState;
    }

    default:
      return state;
  }
}
